import WavyLoader from "components/v2/WavyLoader";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";

const CheckoutPageLoader = () => {
	return (
		<Container>
			<PaddingX>
				<div className="mt-4 md:mt-8 flex-1 pb-24 lg:pb-8">
					<div className="max-w-3xl mx-auto">
						{/* Progress Steps Skeleton */}
						<div className="mb-8 flex justify-center">
							<div className="flex items-center">
								{/* Step 1: Delivery */}
								<div className="flex flex-col items-center">
									<WavyLoader height={40} width={40} className="rounded-full" />
									<WavyLoader height={12} width={56} className="mt-2" />
								</div>
								{/* Connector Line */}
								<div className="w-16 sm:w-24 h-[2px] mx-2">
									<WavyLoader height={2} width="100%" className="rounded-full" />
								</div>
								{/* Step 2: Payment */}
								<div className="flex flex-col items-center">
									<WavyLoader height={40} width={40} className="rounded-full" />
									<WavyLoader height={12} width={56} className="mt-2" />
								</div>
							</div>
						</div>

						{/* Main Content Grid */}
						<div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
							{/* Main Content Card - Payment Step */}
							<div className="lg:col-span-3">
								<div className="bg-white rounded-lg border border-gray-200 p-5">
									{/* Payment section header */}
									<WavyLoader height={16} width={80} className="mb-4" />

									{/* Currency selector */}
									<div className="mb-4 md:mb-6">
										<WavyLoader height={14} width={60} className="mb-2" />
										<div className="inline-flex rounded-full p-1 bg-gray-100">
											<WavyLoader height={36} width={80} className="rounded-full" />
											<WavyLoader height={36} width={80} className="rounded-full" />
										</div>
									</div>

									{/* Payment method pills */}
									<div className="space-y-3">
										<WavyLoader height={12} width={100} className="mb-1.5" />
										<div className="flex flex-wrap gap-1.5">
											<WavyLoader height={36} width={100} className="rounded-md" />
											<WavyLoader height={36} width={90} className="rounded-md" />
											<WavyLoader height={36} width={80} className="rounded-md" />
											<WavyLoader height={36} width={100} className="rounded-md" />
										</div>
									</div>

									{/* Payment form area */}
									<div className="border border-gray-200 rounded-lg p-4 bg-gray-50/50">
										<WavyLoader height={12} width={180} className="mb-3" />
										<WavyLoader height={120} width="100%" />
									</div>
								</div>
							</div>

							{/* Order Summary Sidebar */}
							<div className="hidden lg:block lg:col-span-2">
								<div className="bg-gray-50 rounded-lg border border-gray-200 p-4 sticky top-4">
									<WavyLoader height={14} width={80} className="mb-3" />
									<WavyLoader height={12} width={60} className="mb-2" />
									<div className="space-y-1.5 text-xs">
										<div className="flex justify-between">
											<WavyLoader height={14} width={50} />
											<WavyLoader height={14} width={60} />
										</div>
										<div className="flex justify-between">
											<WavyLoader height={14} width={55} />
											<WavyLoader height={14} width={40} />
										</div>
									</div>
									<div className="border-t border-gray-200 mt-2.5 pt-2.5">
										<div className="flex justify-between">
											<WavyLoader height={16} width={40} />
											<WavyLoader height={16} width={60} />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</PaddingX>
		</Container>
	);
};

export default CheckoutPageLoader;
